<template>
  <div class="app-shell">
    <AppSidebar />
    <div class="app-shell-main">
      <div class="app-shell-content">
        <slot />
      </div>
      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppFooter from '@/components/layout/AppFooter.vue';
import AppSidebar from '@/components/layout/AppSidebar.vue';
import capabilitiesService from '@/services/capabilities';
import { hasCapabilitiesCached, saveCapabilitiesSnapshot } from '@/utils/capabilities';

export default {
  name: 'AppShell',
  components: {
    AppFooter,
    AppSidebar
  },
  mounted() {
    this.ensureCapabilitiesLoaded();
  },
  methods: {
    async ensureCapabilitiesLoaded() {
      const token = localStorage.getItem('access_token');
      if (!token || token === 'undefined' || hasCapabilitiesCached()) {
        return;
      }

      try {
        const response = await capabilitiesService.getCapabilities();
        const capabilities = response?.data?.capabilities || {};

        saveCapabilitiesSnapshot({ capabilities });
      } catch (error) {
      }
    }
  }
};
</script>

<style scoped>
.app-shell {
  min-height: 100vh;
  display: flex;
  background: #f9fafb;
}

.app-shell-main {
  flex: 1;
  min-width: 0;
  min-height: 100vh;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

.app-shell-content {
  flex: 1;
}

@media (max-width: 991px) {
  .app-shell-main {
    margin-left: 72px;
  }
}
</style>
